module.exports = __webpack_public_path__ + "static/home-4-d-08b97e98cec659abd91f4debe63eac81.mp4";